/* Hover: reveal the product's second photo (usually the back view) with a soft turn. One fetch per product, cached. */
(function () {
  if (window.__luxHover) return;
  window.__luxHover = true;
  var cache = {};
  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function imgBox(card) {
    var img = card.querySelector('img');
    return img ? img.parentElement : null;
  }
  function getBack(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var imgs = (p.images || []);
      return imgs.length > 1 ? imgs[1] : null;
    }).catch(function () { return null; });
    return cache[handle];
  }
  function attach(card) {
    if (card.dataset.luxFlip) return;
    card.dataset.luxFlip = '1';
    var handle = handleOf(card);
    if (!handle) return;
    card.addEventListener('mouseenter', function () {
      var box = imgBox(card);
      if (!box) return;
      getBack(handle).then(function (src) {
        if (!src) return;
        var o = box.querySelector('.lux-back');
        if (!o) {
          if (getComputedStyle(box).position === 'static') box.style.position = 'relative';
          o = document.createElement('img');
          o.className = 'lux-back';
          o.alt = '';
          o.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
          box.appendChild(o);
        }
        requestAnimationFrame(function () { card.classList.add('lux-flipped'); });
      });
    });
    card.addEventListener('mouseleave', function () { card.classList.remove('lux-flipped'); });
  }
  function scan() {
    if (fine) document.querySelectorAll('product-card, .product-card, .lxh-card, li.grid__item').forEach(attach);
    document.querySelectorAll('.lxh-view').forEach(function (button) {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', function () {
        var active = button.closest('.lxh-card').classList.toggle('is-alternate');
        button.setAttribute('aria-pressed', String(active));
      });
    });

  }
  var css = document.createElement('style');
  css.textContent = '.lux-back{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:3;opacity:0;transform:perspective(900px) rotateY(-12deg) scale(1.02);transform-origin:center;transition:opacity .45s ease,transform .6s cubic-bezier(.2,.7,.2,1);pointer-events:none;background:#F7F3EE}'
    + '.lux-flipped .lux-back{opacity:1;transform:perspective(900px) rotateY(0deg) scale(1)}'
    + '@media (prefers-reduced-motion:reduce){.lux-back{transition:opacity .2s;transform:none!important}}';
  document.head.appendChild(css);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
  new MutationObserver(function () { clearTimeout(window.__luxT); window.__luxT = setTimeout(scan, 300); }).observe(document.documentElement, { childList: true, subtree: true });
})();
